// extracted by mini-css-extract-plugin
module.exports = {"deliveryContainer":"DeliveryItems_deliveryContainer__hE7Cp","deliveryButtonItem":"DeliveryItems_deliveryButtonItem___l6Tz","isToComplete":"DeliveryItems_isToComplete__Z4xD_"};